import React from 'react';
import PropTypes from 'prop-types';
import Lot from "../../../general/js/lot";

export default class LotInfo extends React.PureComponent {

    getStatusMod(name) {
        let stringId = Lot.getStatusStringId(name);
        if (stringId !== null) {
            return `lot-info__status--${stringId}`;
        }
        return '';
    }

    render() {

        return (
            <div className="lot-info">
                {this.props.lotNumber ?
                    <div className="lot-info__name">Lot {this.props.lotNumber}</div>
                    : null}
                {this.props.statusLabel ?
                    <div
                        className={`lot-info__status ${this.getStatusMod(this.props.statusName)}`} dangerouslySetInnerHTML={{__html: this.props.statusLabel}} />
                    : null}
            </div>
        )
    }
}

LotInfo.propTypes = {
    statusLabel: PropTypes.string,
    statusName: PropTypes.string,
};





// WEBPACK FOOTER //
// ./app/components/lot-item/js/LotInfo.js